import { createTheme, styled } from '@mui/material/styles';
import { Rating } from '@mui/material';

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconFilled': {
    color: theme.palette.primary.light,
  },
  '& .MuiRating-iconHover': {
    color: theme.palette.primary.light,
  },
}));

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#0E2465',
    },
    secondary: {
      main: '#7495F8',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#59C39A',
    },
    error: {
      main: '#FF827A',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFD074'
    },
    info: {
      main: '#80A3FF'
    },
    text: {
      primary: "#393939",
      secondary: "#FFFFFF",
    },
  },

  typography: {
    fontFamily: 'Roboto',
    fontSize: 16,
    grayOp: {
      color: '#212121',
      opacity: 0.8
    },
    h1: {
      fontSize: 56
    },
    h2: {
      fontSize: 48
    },
    h3: {
      fontSize: 32
    },
    body2: {
      fontSize: 13
    },
    caption: {
      fontSize: 11
    }
  },

  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', // Igual que Typography
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          height: 40,
        },
        outlinedSecondary: {
          color: '#696F8C',
          borderColor: '#696F8C',
          '&:hover': {
            borderColor: '#8F95B2',
            backgroundColor: 'transparent',
            color: '#8F95B2'
          }
        },
        outlinedSizeLarge: {
          height: 56,
        },
        containedSizeLarge: {
          height: 56,
        },
      }
    },

    MuiInputLabel: {
      styleOverrides:{
        root:{
          color: "#404875"
        }
      }
    },
    MuiPickersLayout:{
      styleOverrides: {
        root: {
          backgroundColor: "#181818 !important",
        }
      }
    },
    MuiPickersToolbarText: {
      styleOverrides: {
        root: {
          "&.Mui-selected":{
            color: '#FFFFFF'
          },
          color: '#A3A9CC'
        },
      }
    },
    MuiClockNumber: {
      styleOverrides: {
        root: {
          color: '#FFFFFF'
        }
      }
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          "&.Mui-disabled":{
            color: '#57629E'
          },
          color: "#FFF"
        }
      }
    },
    MuiDatePickerToolbar: {
      styleOverrides: {
        title: {
          color: '#FFF'
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          color: '#FFF'
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          color: '#FFF'
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          color: '#FFF'
        }
      }
    }
  },
});

export { theme, StyledRating };